import './index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'vue-sonner/style.css'
import GoogleSignInPlugin from 'vue3-google-signin'
import App from './App.vue'
import { router } from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from './queryClient'

import { i18n } from './components/lang/langHandler'

if (import.meta.env.DEV && import.meta.env.VITE_VUE_TRACER_ENABLED !== 'false') {
  void import('./devtools/vueTracerBridge')
}

// Force favicon reload to fix dev mode issues
const updateFavicon = () => {
  const links = document.querySelectorAll<HTMLLinkElement>("link[rel*='icon']")
  links.forEach((link: HTMLLinkElement) => {
    const url = link.href
    link.href = url + '?v=' + new Date().getTime()
  })
}
document.addEventListener('DOMContentLoaded', updateFavicon) // TODO: investigate requirednesssss

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, { queryClient })
app.use(GoogleSignInPlugin, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
})
app.use(i18n)
app.mount('#app')
